import { sendAnalyticsEvent } from '$lib/services/analytics';
import { EventNames } from '$lib/types/analytics';
import Logger from './logger';

/**
 * Shares the URL using the Web Share API.
 * @param url - URL to share
 */
export const onShare = async (shareOptions: ShareData, cb?: (shareOptions: ShareData) => void) => {
  try {
    if (navigator.share) {
      await navigator.share(shareOptions);
      cb && cb(shareOptions);
    }
  } catch (e) {
    Logger.error(`Error while sharing, ${e}`);
  }
};

export const sendContentSharedEvent = (shareOptions: ShareData) => {
  sendAnalyticsEvent(EventNames.CONTENT_SHARED, {
    shareOptions
  });
};
